export const listDirectoryContent: string = "listDirectoryContent"
export const Upload: string = "upload"
export const AutomationConfig: string = "automationConfig"
export const fileDetails: string = "fileDetails"

export const AssetURL = "https://product-assets.draeger.net/";

export const internalNameToDisplayNameType = {
    "image": "Images",
    "secret": "Secret Files",
    "document": "Documents"
};

export const displayNameToInternalNameType = {};

// invert dictionary
Object.keys(internalNameToDisplayNameType).forEach(internalName => displayNameToInternalNameType[internalNameToDisplayNameType[internalName]] = internalName);

export const displayToInternalName = s => {
    Object.keys(displayNameToInternalNameType).forEach(displayName => s = s.replace(displayName, displayNameToInternalNameType[displayName]));
    return s;
}

export enum ItemType {
    File, Directory
}

const list = Object.keys(internalNameToDisplayNameType);
// null/empty is valid in case of the root level where you first need to select the type
export type DpasFileType = "image" | "secret" | "document" | ""; //typeof list[number]; // fileType should be a string: either "image" or "documents" or "secrets", according to the dic. this type might need "strict" TS mode enabled

// const test: DpasFileType = "c";

export const IsImage = (type : DpasFileType) => type == "image" || type == internalNameToDisplayNameType["image"];